import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { Button as ButtonComponent, RenderButtonProps } from '../buttons';
import { mergeClasses } from '@/utils/style';
export function Button(props) {
  const $ = _c(10);
  let buttonProps;
  let className;
  let size;
  if ($[0] !== props) {
    ({
      className,
      size,
      ...buttonProps
    } = props);
    $[0] = props;
    $[1] = buttonProps;
    $[2] = className;
    $[3] = size;
  } else {
    buttonProps = $[1];
    className = $[2];
    size = $[3];
  }
  const t0 = size || "md";
  let t1;
  if ($[4] !== className) {
    t1 = mergeClasses("mt-6 max-lg:mx-auto lg:mt-8", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== buttonProps || $[7] !== t0 || $[8] !== t1) {
    t2 = <ButtonComponent {...buttonProps} size={t0} className={t1} />;
    $[6] = buttonProps;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}